export enum UserChangeReason {
    Unknown,

    Login,
    Logout,
    SignUp,
}
